import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=e7d18da0&scoped=true"
import script from "./MainOrder.vue?vue&type=script&lang=ts"
export * from "./MainOrder.vue?vue&type=script&lang=ts"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=e7d18da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d18da0",
  null
  
)

export default component.exports